module.exports = __webpack_public_path__ + "img/logo-user.94a56f2.png";